import { render, staticRenderFns } from "./VideoFooter.vue?vue&type=template&id=9247b9ee&scoped=true"
import script from "./VideoFooter.vue?vue&type=script&lang=ts"
export * from "./VideoFooter.vue?vue&type=script&lang=ts"
import style0 from "./VideoFooter.vue?vue&type=style&index=0&id=9247b9ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9247b9ee",
  null
  
)

export default component.exports